import { Image } from '@app/components'
import React, { CSSProperties } from 'react'

export const UsdtIcon = ({ style }: { style?: CSSProperties }) => {
  return <Image preview={false} src="../images/usdt-coin.png" style={style} />
}
